module.exports = __webpack_public_path__ + "img/club.ccfddfe2.svg";